// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__Och3Q","time":"Timer_time__CBRKQ"};